var React = require('react');

function CircleCheckFull (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z","fill":"#A7FFD9","stroke":"#A7FFD9","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.3107 8.04297C17.7012 8.43349 17.7012 9.06666 17.3107 9.45718L11.1036 15.9572C10.7131 16.3477 10.0799 16.3477 9.68938 15.9572L6.68938 12.9572C6.29885 12.5667 6.29885 11.9335 6.68938 11.543C7.0799 11.1524 7.71307 11.1524 8.10359 11.543L10.3965 13.8359L15.8965 8.04297C16.287 7.65244 16.9202 7.65244 17.3107 8.04297Z","fill":"#32213A","key":1})]);
}

CircleCheckFull.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CircleCheckFull;

CircleCheckFull.default = CircleCheckFull;
